var thisFolderDomain = document.domain;
var retryCount = 0;
if (thisFolderDomain == "ti.com") thisFolderDomain = "www.ti.com";

searchClick404 = function() {
    $(".searchFlyout404").removeClass("active focused");
    $(".searchHistory404").removeClass("active");
    $(".searchSuggest404").removeClass("active");
    $(".searchFlyout404").addClass("active filtered");
    $(".searchFilter404").addClass("active");
    $(".searchFilter404").show()
};

function checkForFunction404() {
    if (typeof _tiAnalyticsTrack !== "undefined") {
        _tiAnalyticsTrack("Link Track", "404 Search", "404 ErrorPage-en", "404 ErrorPage")
    } else {
        while (retryCount < 5) {
            setTimeout(function() {
                checkForFunction404()
            }, 500);
            retryCount++
        }
    }
}

function loadSearchUrl404() {
    checkForFunction404();
    $(".searchFlyout404").removeClass("active filtered");
    $(".searchFlyout404").removeClass("active focused");
}
$(document).ready(function() {
	//vars to avoid sonar issues
	var rsData = window.rsData;
	var linkSearch = window.linkSearch;
	var NarrowSearch = window.NarrowSearch;

    var searchhtml404 = '<div class="searchFlyout404"><div class="searchFilter404"><h4>' + NarrowSearch.NarrowSearch_label + '</h4><p class="everything searchFocus404"><a style="cursor:pointer">' + linkSearch[1] + '</a></p><p class="product searchFocus404"><a style="cursor:pointer">' + linkSearch[2] + '</a></p><p class="technicalDocument searchFocus404"><a style="cursor:pointer">' + linkSearch[3] + '</a></p><p class="support searchFocus404"><a style="cursor:pointer">' + linkSearch[13] + '</a></p><p class="crossReference searchFocus404"><a style="cursor:pointer">' + linkSearch[8] + '</a></p><p class="application searchFocus404"><a style="cursor:pointer">' + linkSearch[5] + '</a></p><p class="forum searchFocus404"><a style="cursor:pointer">' + linkSearch[6] + '</a></p><p class="blog searchFocus404"><a style="cursor:pointer">' + linkSearch[7] + '</a></p><p class="designNetwork searchFocus404"><a style="cursor:pointer">' + linkSearch[9] + '</a></p><p class="developerWiki searchFocus404"><a style="cursor:pointer">' + linkSearch[10] + '</a></p><p class="training searchFocus404"><a style="cursor:pointer">' + linkSearch[11] + '</a></p><p class="video searchFocus404"><a style="cursor:pointer">' + linkSearch[12] + '</a></p><p class="support searchFocus404"><a style="cursor:pointer">' + linkSearch[15] + '</a></p></div><div class="searchHistory404"></div><div class="searchSuggest404"></div></div>';
    $("#searchButton404").after(searchhtml404);
    $("#txt_input_404").keyup(function() {
        window.limits($(this), 250)
    });
    $.each($(".searchFocus404"), function() {
        $(this).click(function() {
            $("#searchFilterLab404Text").text($(this).text());
            linkName = $("#searchFilterLab404Text").text();
            metricsOption = $(".searchFocus404").parent().parent().attr("class");
            $(".searchFlyout404").removeClass("active filtered")
        })
    });
    $("#txt_input_404").focus(function(b) {
        if ($("#txt_input_404").val().length < 3) {
            if ($("#searchFilterLab404Text").text() != linkSearch[1]) {
                if (rsData.length <= 0) {
                    $(".searchFlyout404").removeClass("active focused")
                } else {
                    $(".searchFlyout404").addClass("active focused")
                }
                $(".searchFlyout404").removeClass("active filtered");
                $(".searchSuggest404").removeClass("active");
                $(".searchFilter404").hide();
				//this had s inside html() function as param but was undefined. took out to remove sonar issue
                $(".searchHistory404").html();
                $(".searchHistory404").addClass("active")
            } else {
                $(".searchFlyout404").removeClass("active filtered");
                $(".searchSuggest404").removeClass("active");
                $(".searchFlyout404").addClass("active focused");
                $(".searchFilter404").addClass("active");
                $(".searchHistory404").addClass("active");
                $(".searchFilter404").show()
            }
        }
        if ($("#txt_input_404").val().length == 0) {
            autoFill404("usautocmain", "#txt_input_404", null)
        }
    });
    $("#txt_input_404").bind("keyup", function(b) {
        liSelected = $(".searchSuggest404 .selected");
        txtAutoVal = $("#txt_input_404").val();
        if (txtAutoVal.length < 3) {
            if ($("#searchFilterLab404Text").text() != linkSearch[1]) {
                if (rsData.length <= 0) {
                    $(".searchFlyout404").removeClass("active focused")
                } else {
                    $(".searchFlyout404").addClass("active focused")
                }
                $(".searchFlyout404").removeClass("active filtered");
                $(".searchSuggest404").removeClass("active");
                $(".searchFilter404").hide();
				//this had s inside html() function as param but was undefined. took out to remove sonar issue
                $(".searchHistory404").html();
                $(".searchHistory404").addClass("active")
            } else {
                $(".searchFlyout404").removeClass("active filtered");
                $(".searchFlyout404").addClass("active focused");
                $(".searchFilter404").addClass("active");
                $(".searchHistory404").addClass("active");
                $(".searchSuggest404").removeClass("active");
                $(".searchFilter404").show()
            }
        }
        if (window.flag == 0 && txtAutoVal.length > 2) {
            txtAutoVal1 = txtAutoVal;
            window.flag = 1
        }
        if ($(".searchFlyout404 > .searchSuggest").is(":visible")) {
            if (txtAutoVal != txtAutoVal1 && txtAutoVal != liSelected.text()) {
                txtAutoVal1 = txtAutoVal;
                autoFill404("usautocmain", "#txt_input_404", txtAutoVal1)
            }
        } else {
            autoFill404("usautocmain", "#txt_input_404", txtAutoVal)
        }
    });
    $("#txt_input_404").keydown(function(g) {
        liSelected = $(".searchSuggest404 .selected").css("background", "#DDD");
        if (g.which === 40) {
            g.preventDefault();
            if (liSelected.length) {
                var h = liSelected.next();
                if (h.length) {
                    liSelected.removeClass("selected").css("background", "none");
                    liSelected = h.addClass("selected").css("background", "#DDD");
                    $("#txt_input_404").val(liSelected.text())
                } else {
                    $("#txt_input_404").val(txtAutoVal1);
                    $("#txt_input_404").focus();
                    liSelected.removeClass("selected").css("background", "none")
                }
            } else {
                liSelected.removeClass("selected").css("background", "none");
                if ($(".searchSuggest p").eq(0).html() != null && $(".searchSuggest p").eq(0).html().toLowerCase() == "<b>" + NarrowSearch.RecentSearch_label + "</b>" && liSelected.length == 0) {
                    liSelected = $(".searchSuggest p").eq(1).addClass("selected").css("background", "#DDD")
                } else {
                    liSelected = $(".searchSuggest p").eq(0).addClass("selected").css("background", "#DDD")
                }
                $("#txt_input_404").val(liSelected.text())
            }
        } else {
            if (g.which === 38) {
                g.preventDefault();
                if (liSelected.length) {
                    var b = liSelected.prev();
                    if (b.length) {
                        liSelected.removeClass("selected").css("background", "none");
                        if ($(".searchSuggest p").eq(0).html() != null && $(".searchSuggest p").eq(0).html().toLowerCase() == "<b>" + NarrowSearch.RecentSearch_label + "</b>" && b.prev().length == 0) {
                            liSelected = $(".searchSuggest p").eq(-1).addClass("selected").css("background", "#DDD")
                        } else {
                            liSelected = b.addClass("selected").css("background", "#DDD")
                        }
                        $("#txt_input_404").val(liSelected.text())
                    } else {
                        $("#txt_input_404").val(txtAutoVal1);
                        $("#txt_input_404").focus();
                        liSelected.removeClass("selected").css("background", "none")
                    }
                } else {
                    liSelected.removeClass("selected").css("background", "none");
                    liSelected = $(".searchSuggest p").eq(-1).addClass("selected").css("background", "#DDD");
                    $("#txt_input_404").val(liSelected.text())
                }
            } else {
                if (g.which === 13) {
                    $("#txt_input_404").val(liSelected.text());
                    $("#usautocmain").hide();
                    $("#txt_input_404").blur()
                }
            }
        }
    });
    $("#txt_input1").focus(function(b) {
        if ($("#txt_input1").val().length == 0) {
            window.autoFill("usautocmain1", "#txt_input1", null)
        }
    });
    if ("ontouchstart" in document.documentElement) {
        document.addEventListener("touchstart", function(a){
            var d = $(".searchFlyout404");
            var j = $("#txt_input_404");
            var b = $("#txt_input1");
            if (!d.is(a.target) && d.has(a.target).length === 0){
                if (!j.is(a.target)) {
                    $(".searchFlyout404").removeClass("active filtered");
                    $(".searchFlyout404").removeClass("active focused")
                }
                if (!b.is(a.target)) {
                    $("#usautocmain1").hide()
                }
            }
        })
    } else {
        $(document).mouseup(function(b) {
            var d = $(".searchFlyout404");
            var e = $("#txt_input_404");
            if (!d.is(b.target) && d.has(b.target).length === 0) {
                if (!e.is(b.target)) {
                    $(".searchFlyout404").removeClass("active filtered");
                    $(".searchFlyout404").removeClass("active focused")
                }
            }
        })
    }
});

function autoFill404(B, A, D) {
    var x = $(A).val();
	//vars to avoid sonar issues
	var acData = window.acData;
	var rsData = window.rsData;
	var gFlag = window.gFlag;
	var linkSearch = window.linkSearch;
    var NarrowSearch = window.NarrowSearch;
    var searchCookie = window.searchCookie;
    x = window.crossiteScripting(x);
    var r = [];
    var N = false;
    var M = 0;
    var y = 0;
    var v = window.getLinkParameter();
    linkName = $("#searchFilterLab404Text").text();
    link = NarrowSearch[linkName];
    if (A == "#txt_input_404") {
        link = NarrowSearch[linkName]
    } else {
        link = v
    }
    if (rsData.length == 0) {
        if (searchCookie != "" && searchCookie != "null" && searchCookie != null && typeof(searchCookie) !== "undefined") {
            searchCookie = searchCookie.replace(/"/g, "");
            if (searchCookie != "" && searchCookie != "null" && searchCookie != null && typeof(searchCookie) !== "undefined") {
                var O = searchCookie.split("@");
                if (O.length > 6) {
                    maxLength = 6
                } else {
                    maxLength = O.length
                }
                if (O && maxLength > 0) {
                    for (var i = 0; i < maxLength; i++) {
                        var L = O[i].split("|");
                        if (L && L.length > 0 && L[0].length > 0) {
                            rsData.push(L[0])
                        }
                    }
                }
            }
        }
    }
    if ((x.length < 3 || $.inArray(x, rsData) >= 0) && rsData.length > 0) {
        if (x.length < 3) {
            var C = "<p><b>" + NarrowSearch.RecentSearch_label + "</b></p>";
            for (var z = 0; z < rsData.length; z++) {
                if (A == "#txt_input_404") {
                    var u = '<p><a style="cursor:pointer" href="http://' + thisFolderDomain + '/sitesearch/docs/universalsearch.tsp?searchTerm=' + rsData[z].replace(/\"/g, "&quot;") + '#linkId=[[linkId]]&src=top&r=1&m=dd" onClick="loadSearchUrl404();">' + rsData[z].replace(/\"/g, "&quot;") + "</a></p>"
                } else {
                    var u = '<p><a style="cursor:pointer" href="http://' + thisFolderDomain + '/sitesearch/docs/universalsearch.tsp?searchTerm=' + rsData[z].replace(/\"/g, "&quot;") + '#linkId=[[linkId]]" onClick="loadSearchUrl404();">' + rsData[z].replace(/\"/g, "&quot;") + "</a></p>"
                }
                if (gFlag == 2) {
                    u = u.replace("&m=dd", "&m=f")
                }
                u = u.replace("[[linkId]]", link);
                C += u
            }
            if (B != "usautocmain") {
                document.getElementById(B).innerHTML = C
            }
            if (document.getElementsByTagName("div")) {
                var p = document.getElementsByTagName("div");
                for (var z = 0; z < p.length; z++) {
                    if (p[z].className == "usresult") {
                        p[z].style.zIndex = -1
                    }
                }
            }
        }
        if (A == "#txt_input_404") {
            if (x.length < 3) {
                if ($("#searchFilterLab404Text").text() != linkSearch[1]) {
                    if (rsData.length <= 0) {
                        $(".searchFlyout404").removeClass("active focused")
                    } else {
                        $(".searchFlyout404").addClass("active focused")
                    }
                    $(".searchSuggest404").removeClass("active");
                    $(".searchFilter404").hide();
                    $(".searchHistory404").html(C);
                    $(".searchHistory404").addClass("active")
                } else {
                    $(".searchSuggest404").removeClass("active");
                    $(".searchHistory404").html(C);
                    $(".searchFlyout404").addClass("active focused");
                    $(".searchFilter404").addClass("active");
                    $(".searchFilter404").show();
                    $(".searchHistory404").addClass("active")
                }
            }
        } else {
            $("#" + B).show()
        }
    }
    if (x.length >= 3) {
        if (acData.length) {
            M = acData.length
        }
        if (M > 0) {
            var w = new RegExp(x, "gi");
            for (var t = 0; t < M; t++) {
                if (acData[t].match(w)) {
                    if (t + 7 == M) {
                        N = true;
                        r = acData.splice(t, t + 7)
                    } else {
                        N = false
                    }
                    break
                }
            }
        } else {
            N = false
        }
        if (N == false) {
            x = encodeURIComponent(x);
            var q = "/sitesearch/docs/autosuggestion.tsp?searchTerm=" + x + "&jsonResponse=autocomplete&callbackFn=autoSuggestionCallback&toHide=autocomplete";
            $.getJSON(q, function(e) {
                acData = [];
                $.each(e, function(h, g) {
                    if (g != "success") {
                        $.each(g, function(k, j) {
                            $.each(j, function(m, l) {
                                if (m == "autoSuggestion") {
                                    acData.push(l)
                                }
                            })
                        })
                    }
                });
                if (r.length) {
                    y = r.length
                }
                if (null == r || y == 0) {
                    if (acData.length > 7) {
                        r = acData.slice(0, 7)
                    } else {
                        r = acData
                    }
                }
                if (r.length > 0) {
                    var d = "";
                    for (var c = 0; c < r.length; c++) {
                        if (A == "#txt_input_404") {
                            var b = '<p><a style="cursor:pointer" href="http://' + thisFolderDomain + '/sitesearch/docs/universalsearch.tsp?searchTerm=' + r[c].replace(/\"/g, "&quot;") + '#linkId=[[linkId]]&src=top&m=[[configId]]" onClick="loadSearchUrl404();">' + r[c].replace(/\"/g, "&quot;") + "</a></p>"
                        } else {
                            var b = '<p><a style="cursor:pointer" href="http://' + thisFolderDomain + '/sitesearch/docs/universalsearch.tsp?searchTerm=' + r[c].replace(/\"/g, "&quot;") + '#linkId=[[linkId]]" onClick="loadSearchUrl404();">' + r[c].replace(/\"/g, "&quot;") + "</a></p>"
                        }
                        b = b.replace("[[linkId]]", link);
                        if (gFlag == 2) {
                            b = b.replace("&m=[[configId]]", "&m=f")
                        }
                        if (gFlag == 1) {
                            b = b.replace("&m=[[configId]]", "&m=dd")
                        }
                        if (gFlag == 0) {
                            b = b.replace("&m=[[configId]]", "")
                        }
                        d += b
                    }
                    if (B != "usautocmain") {
                        document.getElementById(B).innerHTML = d
                    }
                    if (document.getElementsByTagName("div")) {
                        var f = document.getElementsByTagName("div");
                        for (var c = 0; c < f.length; c++) {
                            if (f[c].className == "usresult") {
                                f[c].style.zIndex = -1
                            }
                        }
                    }
                    if (A == "#txt_input_404") {
                        if (x.length > 2) {
                            $(".searchSuggest404").html(d);
                            $(".searchFilter404").removeClass("active");
                            $(".searchHistory404").removeClass("active");
                            $(".searchFlyout404").addClass("active focused");
                            $(".searchSuggest404").addClass("active");
                            $(".searchFilter404").hide()
                        }
                    } else {
                        $("#" + B).show()
                    }
                } else {
                    $("#" + B).empty();
                    $("#" + B).css("display", "none");
                    $(".searchFlyout404").removeClass("active focused");
                    $(".searchFilter404").removeClass("active");
                    $(".searchHistory404").removeClass("active");
                    $(".searchSuggest404").removeClass("active");
                    $(".searchFilter404").hide()
                }
            })
        } else {
            if (r.length) {
                y = r.length
            }
            if (null == r || y == 0) {
                if (acData.length > 7) {
                    r = acData.slice(0, 7)
                } else {
                    r = acData
                }
            }
            if (r.length > 0) {
                var C = "";
                for (var z = 0; z < r.length; z++) {
                    if (A == "#txt_input_404") {
                        var u = '<p><a style="cursor:pointer" href="http://' + thisFolderDomain + '/sitesearch/docs/universalsearch.tsp?searchTerm=' + r[z].replace(/\"/g, "&quot;") + '#linkId=[[linkId]]&src=top&m=[[configId]]" onClick="loadSearchUrl404();">' + r[z].replace(/\"/g, "&quot;") + "</a></p>"
                    } else {
                        var u = '<p><a style="cursor:pointer" href="http://' + thisFolderDomain + '/sitesearch/docs/universalsearch.tsp?searchTerm=' + r[z].replace(/\"/g, "&quot;") + '#linkId=[[linkId]]" onClick="loadSearchUrl404();">' + r[z].replace(/\"/g, "&quot;") + "</a></p>"
                    }
                    u = u.replace("[[linkId]]", link);
                    if (gFlag == 2) {
                        u = u.replace("&m=[[configId]]", "&m=f")
                    }
                    if (gFlag == 1) {
                        u = u.replace("&m=[[configId]]", "&m=dd")
                    }
                    if (gFlag == 0) {
                        u = u.replace("&m=[[configId]]", "")
                    }
                    C += u
                }
                if (B != "usautocmain") {
                    document.getElementById(B).innerHTML = C
                }
                if (document.getElementsByTagName("div")) {
                    var p = document.getElementsByTagName("div");
                    for (var z = 0; z < p.length; z++) {
                        if (p[z].className == "usresult") {
                            p[z].style.zIndex = -1
                        }
                    }
                }
                if (A == "#txt_input_404") {
                    if (x.length > 2) {
                        $(".searchSuggest404").html(C);
                        $(".searchFilter404").removeClass("active");
                        $(".searchHistory404").removeClass("active");
                        $(".searchFlyout404").addClass("active focused");
                        $(".searchSuggest404").addClass("active");
                        $(".searchFilter404").hide()
                    }
                } else {
                    $("#" + B).show()
                }
            } else {
                $("#" + B).empty();
                $("#" + B).css("display", "none");
                $(".searchFlyout404").removeClass("active focused");
                $(".searchFilter404").removeClass("active");
                $(".searchHistory404").removeClass("active");
                $(".searchSuggest404").removeClass("active");
                $(".searchFilter404").hide()
            }
        }
    }
};